import PublicHeader from './layout/PublicHeader';
import OverViewContent from './main/overview/Content';

const PublicOverviewPage = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <PublicHeader />
            <div className="max-w-hello mx-auto">
                <OverViewContent />
            </div>
        </div>
    );
};

export default PublicOverviewPage;